import { Component, Input } from '@angular/core'
import { FeatureProperty } from '@classes/FeatureProperty'
import { FileReferenceService } from '@services/file-reference.service'
import { ModelService } from '@services/model.service'
import { ProjectService } from '@services/project.service'

@Component({
    selector: 'shared-view-attachment-list',
    templateUrl: './view-attachment-list.component.html',
    styleUrls: ['./view-attachment-list.component.css'],
    standalone: false
})
export class ViewAttachmentListComponent {
    @Input() attachments: FeatureProperty[]

    constructor(
        private _fileReferenceService: FileReferenceService,
        private _modelService: ModelService,
        private _projectService: ProjectService,
    ) { }

    /** Returns true if this attachment is a local file (EFS or S3), not a remote URL */
    isStoredFile(attachment: FeatureProperty): boolean {
        return attachment.isStoredFile
    }

    /** Get the display filename for a local attachment */
    getFilename(attachment: FeatureProperty): string {
        return attachment.displayFilename
    }

    getIcon(attachmentProperty: FeatureProperty) {
        const filename = attachmentProperty?.fileReference?.filename ?? attachmentProperty?.s3ObjectReference?.filename
        return this._modelService.iconClasses(filename)
    }

    openAttachment(attachmentProperty: FeatureProperty) {
        if (attachmentProperty.s3ObjectReferenceId && !attachmentProperty.fileReferenceID) {
            this._fileReferenceService.downloadS3File(
                attachmentProperty.s3ObjectReferenceId,
                attachmentProperty.s3ObjectReference?.filename
            ).subscribe({
                error: err => console.error('Failed to download S3 attachment:', err)
            })
        } else {
            const fileReference = attachmentProperty.fileReference
            const assetID = this.getLinkedAssetID(attachmentProperty)
            const fileOwnerID = assetID ?? this._projectService.currentProject.id
            const fileContext = assetID != null ? 'asset' : undefined

            this._fileReferenceService.openFile(fileReference, fileOwnerID, fileContext).subscribe()
        }
    }

    private getLinkedAssetID(attachmentProperty: FeatureProperty): number | undefined {
        if (attachmentProperty.type != 'asset') return undefined

        try {
            const { assetID } = JSON.parse(attachmentProperty.value)
            return assetID == null ? undefined : +assetID
        } catch (e) {
            return undefined
        }
    }
}
